<script>
import devData from './dev-data/weekly-milling-qty.json'
import api from '@/helpers/api'
import { sumBy, chain, meanBy } from 'lodash'
import moment from 'moment'
import yearRangeMixin from './year-range.mixin'

export default {
  name: 'weekly-milling-avg.card.card',
  mixins: [yearRangeMixin],
  watch: {
    year: 'onRefresh'
  },
  data () {
    return {
      quantity: 0,
      trend: 0,
      prevTrend: 0,
      trendUp: true
    }
  },
  mounted () {
    this.onRefresh()
  },
  methods: {
    async onRefresh () {
      var result = []
      if (process.env.NODE_ENV !== 'production') {
        result = devData
      } else {
        result = await api.stats.weeklyQuantityByTag({
          start_date: this.yearStartFormatted,
          end_date: this.yearEndFormatted,
          tag: 'stat_qty_milling'
        })
      }

      var thisWeek = moment().startOf('isoWeek')
      var lastWeek = moment(thisWeek).subtract(1, 'month')

      var grouped = chain(result)
        .groupBy(x => moment(x.start_date).startOf('isoWeek'))
        .map((data, id) => ({
          start_date: id,
          value: sumBy(data, 'quantity')
        }))
        .value()

      this.quantity = meanBy(grouped, 'value').toFixed(0)

      this.prevTrend = meanBy(
        grouped.filter(x => moment(x.start_date).isBefore(lastWeek)),
        'value'
      ).toFixed(0)

      var trend = ((this.quantity / this.prevTrend - 1) * 100).toFixed(0)
      if (this.prevTrend === 0) trend = 0

      this.trend = Math.abs(trend)
      this.trendUp = trend > 0
    }
  }
}
</script>
<template>
  <div class="portal-card portal-card--metric">
    <div class="portal-card__eyebrow">{{ $t('Avg Weekly Millings') }}</div>
    <div class="portal-card__value">{{ quantity }}</div>
    <div class="portal-card__trend">
      <span
        class="portal-card__trend-value"
        :class="trendUp ? 'is-up' : 'is-down'"
      >
        <i
          :class="trendUp ? 'mdi mdi-trending-up' : 'mdi mdi-trending-down'"
        ></i>
        {{ formatTrendPercent(trendUp ? trend : -trend) }}
      </span>
      <span class="portal-card__trend-label">{{
        $t('stats.sales.since_last_week')
      }}
        ({{ prevTrend }})</span
      >
    </div>
  </div>
</template>
